export const enum EAccountStatus {
  new = 0,
  active = 1,
  blocked = 2,
}
// статус аккаунта (0 – новый, 1 – активирован, 2 – заблокирован),
